// Reines, framework-freies Modul: sowohl der Navigations-Guard
// (router/index.js) als auch der Post-Login-Redirect (LoginView.vue:
// safeRedirect) muessen dieselbe Entscheidung treffen, ob eine Route zum
// Bereich (intern/Portal) einer Rolle passt - vorher gab es das nur in
// EINE Richtung (Reader durfte den internen Bereich nicht betreten), nicht
// umgekehrt. Ein internes Konto (admin/pm/analyst), das z.B. ueber einen
// alten ?redirect=-Query-Param, einen Bookmark oder manuelle Eingabe auf
// einer /portal/*-Route landete, wurde nie zurueckgeschickt - App.vue
// waehlt das Layout rein nach route.meta.area, PortalLayout.vue filtert
// sein Menue nur nach page_keys (die ein Admin fuer "portal.*" nie hat) -
// sichtbar blieb nur der ungefilterte "Konto"-Link, alle internen Reiter
// verschwanden (Live-Bug nach Domainwechsel).
//
// 'portal-account' (die "Konto"-Seite) ist bewusst ausgenommen - sie ist
// die einzige Profilseite der gesamten App, es gibt kein internes Pendant.

export const ACCOUNT_ROUTE_NAME = 'portal-account'

/**
 * @param {{ isExternal: boolean, area: string|undefined, routeName: string|undefined|symbol }} args
 * @returns {boolean} true, wenn die Route NICHT zur Rolle passt (sollte umgeleitet werden)
 */
export function isAreaMismatch({ isExternal, area, routeName }) {
  if (routeName === ACCOUNT_ROUTE_NAME) return false
  if (isExternal && area === 'internal') return true
  if (!isExternal && area === 'portal') return true
  return false
}
